import { GraphQLClient } from 'graphql-request';

import { getGraphQlEndpoint } from '@/api/backendAPI';
import { COUNTRY_COOKIE, STATSIG_COOKIE } from '@/app/consts/cookies';

import { getCookie } from './cookie';

const gqlClient = (extraHeaders: Record<string, string> = {}) => {
  const statsigStableId = getCookie(STATSIG_COOKIE) ?? '';
  const country = getCookie(COUNTRY_COOKIE) ?? '';

  const headers = {
    'x-statsig-stable-id': statsigStableId,
    'x-country': country,
    ...extraHeaders,
  };

  return new GraphQLClient(getGraphQlEndpoint()!, {
    headers,
  });
};

export default gqlClient;
